import * as React from 'react';
import { TeamListViewBase } from '../teamListView/TeamListViewBase';
import { BaseRouteProps } from '../../../interfaces';
import { UserStore, FilterStore } from '../../../stores';

interface TeamListViewRIReportProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

export class TeamListViewRIReport extends React.Component<TeamListViewRIReportProps, {}> {
    public render() {
        return <TeamListViewBase 
            {...this.props} 
            title="PVA Team List View RI" 
            numColumns={4} 
            showResponseIndicator={true} 
        />;
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/teamListViewRI/TeamListViewRIReport.tsx